export type StartupRecoveryCopy = {
  title: string;
  description: string;
  action: string;
};

export function getStartupRecoveryCopy(message: string): StartupRecoveryCopy {
  if (message.includes('подключённого бота')) {
    return {
      title: 'Откройте витрину из бота',
      description: 'Так мы безопасно определим ваш профиль, организацию и доступные действия.',
      action: 'Проверить запуск',
    };
  }

  return {
    title: 'Витрина временно недоступна',
    description: message || 'Проверьте подключение и попробуйте открыть витрину ещё раз.',
    action: 'Попробовать снова',
  };
}
